<template>
  <div class="card mb-0 shadow">
    <div class="card-body">
      <div class="tab-content">
        <div
          class="animate__animated animate__fadeIn"
          style="height: 600px; overflow-y: auto; overflow-x: hidden"
        >
          <Page titulo="Plano de Atendimento Familiar - PAF" mode="table" />
        </div>
      </div>
    </div>
  </div> 
</template> 
<script>
import Page from "./ShowPAF.vue";
export default {
  components: { Page },
  props: ["item"],
};
</script>
<style scoped>
</style>
